import Glossary from "components/templates/glossary/Glossary";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "GLOSSARY",
  label: "Lexique",
  Component: Glossary,
  initialContents: [
    {
      key: "glossary",
      type: elementsTypes.GLOSSARY,
      value: "",
      children: [],
    },
  ],
};
